module.exports = __webpack_public_path__ + "img/Johnson_Johnson.1be0bee2.jpg";